const RadioButton = ({ children, label = "", ...rest }) => {
    return (
        <label className="checkbox-container">
            <input type="radio" className="checkbox" {...rest} />
            <span className={"round-span"}></span>
            <span className="checkbox-label">{children || label}</span>
        </label>
    );
};

export default RadioButton;
